/*
 *   File : basket.js
 *   Author : https://evoqins.com
 *   Description : Basket card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// Component
import { Icon } from "../Icon";

//custom styles
import styles from "../../Style/Component/card.module.scss";

// Color
import Colors from "../../Style/color.scss";

//assets
import RightArrow from "../../Assets/Images/right-icon.svg";

const BasketCard = (props) => {

    const style = {
        "--background": props.data.color,
    };

    return (
        <>
            {
                props.type === "modal" ?
                    <div style={style}
                        className={`${styles.e_basket_modal_card} transition e-border-radius-16 px-3 px-sm-4 py-3 cursor-pointer`}
                        onClick={props.handleSelect} >
                        <div className="d-flex align-items-center e-basket-card-title gap-xl-3 gap-lg-3 gap-sm-2 gap-md-1 gap-1">
                            <Icon icon={props.selected === props.data.basket_id ? 'circle-active' : 'circle-inactive'}
                                size="24px"
                                color={Colors.white} />
                            <img src={props.data.icon}
                                draggable={false}
                                height={38}
                                width={38}
                                alt="invest" />
                            <div>
                                <p className=" mb-0 e-text-white e-font-14 e-alt-font-poppins e-font-weight-600 line-height-20px w-max-content">
                                    {props.data.name}
                                </p>

                                <div className="d-flex justify-content-center align-items-center e-flex-wrap">
                                    <p className="mb-0 pe-1 e-text-white e-font-14 e-alt-font-poppins e-font-weight-400 line-height-20px w-max-content">
                                        {props.data.returns.tenure_text} returns :
                                    </p>
                                    <p className={`${props.data.returns.returns_percentage >= 0 ? "e-text-ufo-green" : "e-text-red"}  mb-0 e-text-ufo-green e-font-16 e-font-weight-600`}>
                                        {props.data.returns.returns_percentage_text}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div >
                    :
                    props.type === 2 ?
                        <div className="d-flex flex-column p-1 e-border-radius-20 h-100 w-100 card-hover cursor-pointer"
                            style={{ background: props.data.color }}
                            onClick={props.onClick}>
                            <div className="e-bg-white e-border-radius-20 p-3 mb-1 flex-fill">
                                <div className="d-flex gap-3 align-items-center mb-3">
                                    <img src={props.data.icon}
                                        alt="icon"
                                        height={40}
                                        width={40}
                                        className="object-fit-contain"
                                        draggable={false}
                                    />
                                    <p className="e-text-onyx e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-500 line-height-20px mb-0">
                                        {props.data.name}
                                    </p>
                                </div>
                                <p className="e-text-eerie-black e-font-12 e-alt-font-poppins e-font-weight-500 line-height-16px mb-0">Avg Returns</p>
                                <span className="e-text-persian-green e-font-12 e-alt-font-poppins e-font-weight-600 line-height-16px " style={{ fontWeight: 600 }}>
                                    {props.data.returns.returns_percentage_text}
                                </span>
                            </div>
                            <span className="d-block e-text-rhythm text-center e-font-12 e-alt-font-poppins e-font-weight-600 line-height-14px">
                                {props.data?.short_name}
                            </span>

                        </div>
                        :
                        <div style={style}
                            className={`${styles.e_basket_card} transition e-border-radius-16 p-3 cursor-pointer `}
                            onClick={props.onClick}>
                            <div className="e-inline-flex e-basket-card-title gap-2 gap-sm-2 gap-md-1">
                                <img src={props.data.icon}
                                    draggable={false}
                                    className="mb-1"
                                    height={48}
                                    width={48}
                                    alt="invest" />
                                {/* <p className="e-font-20-res mb-0 padding-12px-left e-text-white e-font-18 e-alt-font-poppins e-font-weight-600 line-height-22px"> */}
                                <p className="e-font-16-res mb-0 padding-12px-left e-text-onyx e-font-18 e-alt-font-poppins e-font-weight-600 line-height-22px w-max-content">
                                    {props.data.name}
                                </p>
                            </div>
                            <div className="e-display-flex justify-content-space-between pt-sm-3">
                                <div className="d-flex justify-content-center align-items-center e-flex-wrap">
                                    <p className="mb-0 pe-1 e-text-onyx e-font-12 e-alt-font-poppins e-font-weight-400 line-height-18px w-max-content">
                                        {/* {props.data.returns.tenure_text} returns : */}
                                        Ideal for 10Y period
                                    </p>
                                    {/* <p className={`${props.data.returns.returns_percentage >= 0 ? "e-text-ufo-green" : "e-text-red"} e-font-14-res mb-0 e-text-ufo-green e-font-16 e-font-weight-600`}>
                                {props.data.returns.returns_percentage_text}
                            </p> */}
                                </div>
                            <Icon icon="right-black-icon" size={24} className={`${styles.e_right_arrow} transition`} />
                            </div>
                        </div>
            }
        </>
    )
}
export default BasketCard;